export default __webpack_public_path__ + "static/media/KC.ca193598.svg";